var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-tool",attrs:{"id":"image-tool"}},[_c('div',{staticStyle:{"padding-bottom":"20px"}},[(_vm.imagePath !== '')?_c('stage'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }